module.exports = __webpack_public_path__ + "static/media/mountains.4130575d.jpeg";